import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { LogLevel, Configuration, BrowserCacheLocation, IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { environment } from '../../../../environments/environment';
import { AuthService } from './auth.service';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(<Configuration>{
    auth: {
      clientId: environment.azureADauthClient,
      authority: environment.azureADauthAuthority,
      redirectUri: environment.authRedirectUrl,
      postLogoutRedirectUri: environment.authLogoutRedirectUrl,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
        loggerCallback: (logLevel: LogLevel, message: string) => {
          console.log(`MSAL Log - $logLevel: ${logLevel} - message: ${message}`);
        },
      },
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
    },
    loginFailedRoute: '/home',
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      ['https://graph.microsoft.com/v1.0/me', ['user.read']],
      ['/api/*', [AuthService.apiScope]], // api you host
    ]),
  };
}
